
import moment from "moment";

import "../../App.css";
import { capitalizeFirstLetter } from "../../OrderPage/AllOrders.js";
const statusColors = {
    cancelled: "text-red-500 border border-red-500 hover:bg-red-500 hover:text-white",
    pending: "text-[#5C74FB] border border-[#5C74FB] hover:bg-[#5C74FB] hover:text-white",
    booked: "text-[#5C74FB] border border-[#5C74FB] hover:bg-[#5C74FB] hover:text-white",
    "pending pickup": "text-[#5C74FB] border border-[#5C74FB] hover:bg-[#5C74FB] hover:text-white",
    "in transit": "text-[#5C74FB] border border-[#5C74FB] hover:bg-[#5C74FB] hover:text-white",
    "out for delivery": "text-[#5C74FB] border border-[#5C74FB] hover:bg-[#5C74FB] hover:text-white",
    delivered: "text-[#5C74FB] border border-[#5C74FB] hover:bg-[#5C74FB] hover:text-white",
    rto: "text-slate-600 border border-slate-600 hover:bg-slate-600 hover:text-white",
    "rto delivered": "text-slate-600 border border-slate-600 hover:bg-slate-600 hover:text-white",
};



export const customerPendingPaymentColumns = [
    // {
    //     name: "No.",
    //     sortable: true,
    //     cell: (row, index) => index + 1 + ((page - 1) * limit),
    // },
    {
        name: "Shipment Date",
        sortable: true,
        selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY"),
    },
    {
        name: "Delivered Date",
        sortable: true,
        selector: (row) => moment(row?.delivery_order_Date).format("DD/MM/YYYY"),
    },
    {
        name: "Day Count",
        sortable: true,
        selector: (row) => row?.dayDifference,
    },
    {
        name: "Pickup Name",
        sortable: true,
        selector: (row) => row?.pickupAddress?.name,
    },
    {
        name: "AWB",
        sortable: true,
        selector: (row) => row?.awb_number,
        cell: (row) => <span style={{ color: "#5C74FB", fontWeight: "500" }}>{row.awb_number}</span>,
        width: "150px",
    },

    {
        name: "Shipment No.",
        sortable: true,
        selector: (row) => row?.order_number,
        cell: (row) => <span style={{ color: "#5C74FB", fontWeight: "500" }}>{row.order_number}</span>,
        width: "160px",
    },
    {
        name: "Order ID",
        sortable: true,
        selector: (row) => row?.order_id,
        cell: (row) => <span style={{ color: "#5C74FB", fontWeight: "500" }}>{row.order_id}</span>,
        width: "160px",
    },
    {
        name: "Receiver Details & Address",
        sortable: true,
        selector: (row) => `${row?.deliveryAddress?.name} - ${row?.deliveryAddress?.address}`,
        // cell: (row, index, allRows) => {
        //     const isSingleRow = allRows.length === 1; // Check if there’s only one row
        //     const tooltipClass = isSingleRow || index < 4 ? "tooltip-below" : "tooltip-above";

        //     return (
        //         <div className="tooltip-container">
        //             {row?.deliveryAddress?.name}
        //             <span className={`tooltip-text ${tooltipClass}`}>
        //                 Name. {capitalizeFirstLetter(row?.deliveryAddress?.name)} <br />
        //                 To. {capitalizeFirstLetter(row?.deliveryAddress?.address1)}{" "}
        //                 {capitalizeFirstLetter(row?.deliveryAddress?.city)}.{" "}
        //                 {capitalizeFirstLetter(row?.deliveryAddress?.stateId?.name)} -{" "}
        //                 {row?.deliveryAddress?.zipCode} <br />
        //                 Mo. {row?.deliveryAddress?.phone}
        //             </span>
        //         </div>
        //     );
        // },
        cell: (row) => (
            <div className="tooltip-container">
                {row?.deliveryAddress?.name}
                <div className="tooltip-text tooltip-above">
                    Name. {capitalizeFirstLetter(row?.deliveryAddress?.name)} <br />
                    To. {capitalizeFirstLetter(row?.deliveryAddress?.address1)}{" "}
                    {capitalizeFirstLetter(row?.deliveryAddress?.city)}.{" "}
                    {capitalizeFirstLetter(row?.deliveryAddress?.stateId?.name)} -{" "}
                    {row?.deliveryAddress?.zipCode} <br />
                    Mo. {row?.deliveryAddress?.phone}
                </div>
            </div>
        ),
    },

    // {
    //     name: "Weight (Kg)",
    //     sortable: true,
    //     selector: (row) => row?.package_weight,
    // },
    {
        name: "COD Collectable Rs.",
        sortable: true,
        selector: (row) => (row?.payment_type === "cod" ? `₹${row?.ProductPrice}` : "-"),
    },
    {
        name: "COD Collection Rs.",
        sortable: true,
        selector: (row) => (row?.codCollectableValue ? `₹${row?.codCollectableValue}` : "0"),
    },
    {
        name: "Payment Type",
        sortable: true,
        selector: (row) => row?.payment_type,
    },
    // {
    //     name: "RTO Charges",
    //     sortable: true,
    //     selector: (row) => (row?.rto_order_charge ? `₹${row?.rto_order_charge}` : 0),
    // },

    {
        name: "Total Amount",
        sortable: true,
        selector: (row) => `₹${row?.final_order_amount || 0}`,
    },
    {
        name: "Net Payable Amount (₹)",
        sortable: true,
        selector: (row) => `₹${row?.net_receivable_amount || 0}`,
    },
    {
        name: "Payment Amount Date",
        sortable: true,
        selector: (row) => row?.payment_order_Date ? moment(row?.payment_order_Date).format('DD/MM/YYYY') : "-",
    },
    {
        name: "Status",
        sortable: true,
        selector: (row) => row?.status,
        cell: (row) => (
            <span
                className={`px-4 py-1 rounded-md text-xs font-semibold uppercase tracking-wide border ${statusColors[row?.status] || "bg-slate-500 text-white border border-gray-600"}`}
            >
                {row?.status}
            </span>
        ),
        minWidth: "160px",
    },
    {
        name: "Payment Status",
        sortable: true,
        selector: (row) => row?.cod_payment_status,
        cell: (row) => (
            <span
                className={`px-4 py-1 rounded-md text-xs font-semibold uppercase tracking-wide border ${statusColors[row?.status] || "bg-slate-500 text-white border border-gray-600"}`}
            >
                {row?.cod_payment_status}
            </span>
        ),
        minWidth: "160px",
    }

];

export const orderTableColumns = [
    // {
    //     name: "No.",
    //     sortable: true,
    //     cell: (row, index) => index + 1,
    // },
    {
        name: "ORDER",
        sortable: true,
        selector: (row) => row?.order_number,
        cell: (row) => (row.order_number ? <span style={{ color: "#5C74FB", fontWeight: "500", cursor: "pointer" }} className="text-xs" onClick={() => window.open(`/singletrack?id=${row?._id}`, "_blank")}>{row.order_number}</span> : "-"),
        width: "160px",
    },
    {
        name: "DATE",
        sortable: true,
        selector: (row) => (
            <span className="text-xs">
                {moment(row.createdAt).format("DD/MM/YYYY")}
            </span>
        ),
    },
    {
        name: "AWB",
        sortable: true,
        selector: (row) => row?.awb_number,
        cell: (row) => (
            row?.awb_number ? (
                row?.Shipment_name === "AJ" ? (
                    <span style={{ color: "#5C74FB", fontWeight: "500", cursor: "pointer" }} className="text-xs">
                        {row?.awb_number}
                    </span>
                ) : (
                    <span
                        style={{ color: "#5C74FB", fontWeight: "500", cursor: "pointer" }}
                        className="text-xs"
                        onClick={() => window.open(`/trackcourier?awb=${row?.awb_number}`, "_blank")}
                    >
                        {row?.awb_number}
                    </span>
                )
            ) : "-"
        ),
        // cell: (row) => (row?.awb_number ? <span style={{ color: "#5C74FB", fontWeight: "500", cursor: "pointer" }} className="text-xs" onClick={() => { window.open(`/trackcourier?awb=${row?.awb_number}`, "_blank") }}>{row?.awb_number}</span> : "-"),
        width: "150px",
    },
    {
        name: "Product",
        sortable: true,
        selector: (row) => row?.ProductName || "----",
        cell: (row) => (
            <div className="truncate max-w-xs cursor-pointer text-xs" title={row?.ProductName || "----"}>
                {row?.ProductName || "----"}
            </div>
        ),
    },

    // {
    //     name: "Product",
    //     sortable: true,
    //     selector: (row) => row?.ProductName,
    //     cell: (row) => (
    //         <div className="tooltip-container">
    //             {row?.ProductName}
    //             <div className="tooltip-text tooltip-above">
    //                 {row?.ProductName}
    //             </div>
    //         </div>
    //     ),
    // },

    {
        name: "PAYMENT",
        sortable: true,
        selector: (row) => <span className="text-xs">{row?.ProductPrice}</span>
    },
    {
        name: "METHOD",
        sortable: true,
        selector: (row) => (
            <div className="text-xs">
                {row?.payment_type?.toUpperCase()}{" "}
                {(row?.cod_payment_status === "Paid" || row?.cod_payment_status === "success") && (row?.payment_type === 'cod' &&
                    <span className="text-green-600 text-xs">(P)</span>
                )}
            </div>
        ),
    },
    {
        name: "CUSTOMER",
        sortable: true,
        selector: (row) => `${row?.deliveryAddress?.name || "----"} - ${row?.deliveryAddress?.address || "----"}`,
        cell: (row) => (
            <div
                className="truncate max-w-xs cursor-pointer text-xs"
                title={`Name: ${capitalizeFirstLetter(row?.deliveryAddress?.name || "----")}
    To: ${capitalizeFirstLetter(row?.deliveryAddress?.address1 || "----")} ${capitalizeFirstLetter(row?.deliveryAddress?.city || "----")}. 
    ${capitalizeFirstLetter(row?.deliveryAddress?.stateId?.name || "----")} - ${row?.deliveryAddress?.zipCode || "----"}
    Mo: ${row?.deliveryAddress?.phone || "----"}`}
            >
                {row?.deliveryAddress?.name || "----"}
            </div>
        ),
    },


    // {
    //     name: "CUSTOMER",
    //     sortable: true,
    //     selector: (row) => `${row?.deliveryAddress?.name} - ${row?.deliveryAddress?.address}`,

    //     cell: (row) => (
    //         <div className="tooltip-container">
    //             {row?.deliveryAddress?.name}
    //             <div className="tooltip-text tooltip-above">
    //                 Name. {capitalizeFirstLetter(row?.deliveryAddress?.name)} <br />
    //                 To. {capitalizeFirstLetter(row?.deliveryAddress?.address1)}{" "}
    //                 {capitalizeFirstLetter(row?.deliveryAddress?.city)}.{" "}
    //                 {capitalizeFirstLetter(row?.deliveryAddress?.stateId?.name)} -{" "}
    //                 {row?.deliveryAddress?.zipCode} <br />
    //                 Mo. {row?.deliveryAddress?.phone}
    //             </div>
    //         </div>
    //     ),
    // },
    {
        name: "Village?",
        sortable: true,
        selector: (row) =>
            row?.isDeliverToVillage ? "YES" : "NO",
        cell: (row) => (
            <div
                className="truncate max-w-xs cursor-pointer text-xs"
                title={`Village Delivery? ${row?.VillageName || ""}`}
            >
                {row?.isDeliverToVillage ? "YES" : "NO"}{" "}
                <span className="ml-3 font-semibold text-green-600">
                    {row?.extraChargeOfVillage ? row?.extraChargeOfVillage : ""}
                </span>
            </div>
        ),
    },
    {
        name: "Status",
        sortable: true,
        selector: (row) => row?.status,
        cell: (row) => (
            <span
                {...(row?.trackStatus === 'Drop pincode not serviceable' ? { title: row?.trackStatus } : {})}
                className={`px-4 py-1 cursor-pointer rounded-md text-xs font-semibold capitalize tracking-wide border ${statusColors[row?.status] || "bg-slate-500 text-white border border-gray-600"}`}
            >
                {row?.status}
            </span>
        ),
        minWidth: "160px",
    }
];

export const walletTransactionTableColumns = [

    {
        name: "Date",
        selector: (row) =>
            row?.createdAt ? moment(row.createdAt).format("MMM DD, YYYY hh:mm A") : "-",
        sortable: true,
        width: "180px",
        cell: (row) => (
            <span className="text-xs">
                {row?.createdAt ? moment(row.createdAt).format("MMM DD, YYYY hh:mm A") : "-"}
            </span>
        ),
    },
    {
        name: "Txn Type",
        sortable: true,
        selector: (row) => row?.txnType,
        cell: (row) => <span style={{ color: "#5C74FB", fontWeight: "500" }} className="text-xs">{row?.txnType}</span>,
        width: "150px",
    },
    {
        name: "Ref No#",
        sortable: true,
        selector: (row) => row?.orderId?.awb_number,
        // cell: (row) => <span className="text-xs" onClick={() => window.open(`/shippingcharges?awb=${row?.orderId?.awb_number}`, "_blank")} style={{ color: "#5C74FB", fontWeight: "500", cursor: "pointer" }}>{row?.orderId?.awb_number ? row?.orderId?.awb_number : "-"}</span>,
        width: "160px",
    },

    {
        name: "Transaction ID",
        sortable: true,
        selector: (row) => (
            <span className="text-xs">
                {(row?.transactionId)}
            </span>
        ),
        width: "200px",
    },
    {
        name: "Credit(₹)",
        sortable: true,
        selector: (row) => (
            <span className="text-xs">
                {(row?.credit ? row?.credit : "-")}
            </span>
        ),
    },
    {
        name: "Debit(₹)",
        sortable: true,
        selector: (row) => (
            <span className="text-xs">
                {(row?.debit ? row?.debit : "-")}
            </span>
        ),
    },
    {
        name: "Closing Balance(₹)",
        sortable: true,
        selector: (row) => (
            <span className="text-xs">
                {row?.closingBalance
                }
            </span >
        ),
    },
    {
        name: "Description",
        sortable: true,
        selector: (row) => (
            <span className="text-xs truncate max-w-[160px] block hover:overflow-visible hover:whitespace-normal">
                {row?.description}
            </span>
        ),
        width: "180px",
    },

];
